import { makeStyles } from "@material-ui/core";

export const useUserListsStyles = makeStyles(() => ({
    myLists: {
        height: 316,
        border: 0,
        borderRadius: 0
    }
}));
